module.exports = __webpack_public_path__ + "static/media/databases.cd6fa3df.svg";